import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { firestoreAction, TimeStamp } from 'vuexfire';

export default {
  namespaced: true,
  state: {
    document : []
  },
  getters: {
    document(state){
    return state.document
   }
  },

  actions: {
    doSubmitContactForm: firestoreAction ( ({rootGetters , dispatch}, data) => {
        var id = firebase.firestore().collection('ids').doc().id
        firebase.firestore().collection('contactForm-website').doc(id).set({
            ...data,
            id,
            createdAt: firebase.firestore.Timestamp.now()
        }) 
        dispatch('doEmailSubmission',data)
    }),
    doEmailSubmission: firestoreAction( ({rootGetters}, data) => {
        var lang =  localStorage.getItem('language');
        var templateName = lang == 'ar' ? 'contactEmailToClient-ar-website' : 'contactEmailToClient-website';
        firebase.firestore().collection('mail').add({
            to: data.email,
            template: {
              name: templateName
            },
          })
          firebase.firestore().collection('mail').add({
            to: 'info@israagroup.com',
            template: {
              name: 'contactEmailToIsraa-website',
        data: {
            name: data.name,
            email: data.email,
            message: data.message
          }
            },
          });
    })
  }
}